if (!customElements.get("cart-drawer")) {
  customElements.define(
    "cart-drawer",
    class CartDrawer extends Drawer {
      show(opener) {
        super.show(opener);
        this.refreshEmptyCart();

        const recommendationByHistory = this.querySelector("recommendation-by-history");
        if (recommendationByHistory) recommendationByHistory.showContent();
      }

      refreshEmptyCart() {
        if (!this.querySelector(".cart-details.is-empty") || this.refreshingCart) return;
        this.refreshingCart = true;
        const sections = [
          { id: "Cart-Icon-Bubble", section: "cart-icon-bubble", selector: ".shopify-section" },
          { id: "Cart-Drawer", section: this.dataset.section, selector: "#Cart-Drawer-Details" },
        ];
        const url = new URL(window.routes.cart_url, window.location.origin);
        url.searchParams.set("sections", sections.map(section => section.section).join(","));
        url.searchParams.set("_bs_cart", Date.now());
        fetch(url, { cache: "no-store", credentials: "same-origin" })
          .then(response => {
            if (!response.ok) throw new Error("Cart refresh unavailable");
            return response.json();
          })
          .then(rendered => {
            const available = sections.filter(section => typeof rendered[section.section] === "string");
            SectionDynamicUpdate.updateSections(available, rendered);
            if (this.hasAttribute("open")) webvista.trapFocus(this);
          })
          .catch(() => {})
          .finally(() => { this.refreshingCart = false; });
      }

      hide() {
        super.hide();
        const recommendationByHistory = this.querySelector("recommendation-by-history");
        if (recommendationByHistory) recommendationByHistory.abortFetch();
      }
    },
  );
}
